import { ActionTree } from 'vuex'
import { CompanyState } from './companies.model'
import { MutationTypes } from './companies.mutations'
import getCompaniesForContact from '@/graphql/queries/getCompaniesForContact'
import { authenticatedApolloClient } from '@/services/authenticated-apollo.service'
import { GetCompaniesForContactQuery, GetCompaniesForContactQueryVariables } from '@/graphql/generated/types'

export const actions: ActionTree<CompanyState, unknown> = {
  async GET_COMPANIES({ commit }) {
    try {
      commit(MutationTypes.GET_COMPANIES_REQUEST)
      const {
        data: { getCompaniesForContact: companies }
      } = await authenticatedApolloClient.query<GetCompaniesForContactQuery, GetCompaniesForContactQueryVariables>({
        query: getCompaniesForContact
      })
      commit(MutationTypes.GET_COMPANIES_SUCCESS, companies)
    } catch (err) {
      commit(MutationTypes.GET_COMPANIES_ERROR, err)
    }
  }
}
